import {AfterViewInit, Component, Input} from "@angular/core";
import {NavigateDialogComponent} from "../navigate-dialog/navigate-dialog.component";
import {ExternalLinksEnum} from "../../../core/models/Enums/ExternalLinksEnum";
import {ProjectService} from "../../../core/services/services/project.service";
import {MatDialog} from "@angular/material/dialog";
import {CustomizingService} from "../../../core/services/services/customizing.service";
import {MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatTooltip} from "@angular/material/tooltip";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
	selector: "app-cross-application-link",
	templateUrl: "./cross-application-link.component.html",
	styleUrls: ["./cross-application-link.component.scss"],
	imports: [MatIconButton, MatIcon, MatTooltip, TranslatePipe],
})
export class CrossApplicationLinkComponent implements AfterViewInit {
	@Input()
	projectName: string;
	links: {value: string; viewValue: string}[] = [];

	constructor(
		private _projectService: ProjectService,
		private matDialog: MatDialog,
		private customizing: CustomizingService,
	) {}

	ngAfterViewInit(): void {
		this.customizing.getIsExternalLink().then((showLinks) => {
			if (showLinks === ExternalLinksEnum.CHARISMA || showLinks === ExternalLinksEnum.CHARISMA_OOB) {
				this._projectService.getCharismaLink().subscribe((link) => {
					this.links.push({
						value: link + "/project-list/mep/" + this.encode(this.projectName),
						viewValue: "Charisma",
					});
				});
			}

			if (showLinks === ExternalLinksEnum.OOB || showLinks === ExternalLinksEnum.CHARISMA_OOB) {
				this._projectService.getOOBLink().subscribe((link) => {
					this.links.push({
						value: link + "/project-list/mep/" + this.encode(this.projectName),
						viewValue: "OOB",
					});
				});
			}
		});
	}

	openNavigateDialog() {
		this.matDialog.open(NavigateDialogComponent, {
			disableClose: true,
			width: "300px",
			data: this.links,
		});
	}

	private encode(projectName: string) {
		if (projectName) {
			// manually encoded because %2F reads still as slash in url and throws 400 Error
			let encodedName = this.replaceAll(projectName, "/", "~2F");
			encodedName = this.replaceAll(encodedName, "#", "~23");
			encodedName = this.replaceAll(encodedName, "?", "~3F");
			// encode bracket manually
			encodedName = this.replaceAll(encodedName, "(", "%28");
			encodedName = this.replaceAll(encodedName, ")", "%29");
			return encodedName;
		}
		return projectName;
	}

	private escapeRegExp(string) {
		return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
	}

	private replaceAll(str, find, replace) {
		return str.replace(new RegExp(this.escapeRegExp(find), "g"), replace);
	}
}
